export default {
	EmptyEmail: 'Lütfen eposta adresinizi yazın.',
	EmptyPassword: 'Lütfen şifrenizi yazın.',
};
